import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Modal from "react-modal";
import { Link } from "react-router-dom";

function CourseviewDetails() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [courseDetails, setCourseDetails] = useState(null); // State to hold course details
    const query = new URLSearchParams(useLocation().search); // Get query parameters
    const courseId = query.get("id"); // Extract the course ID from the query parameters

    useEffect(() => {
        const fetchCourseDetails = async () => {
            if (courseId) {
                try {
                    // const response = await fetch(`${process.env.REACT_APP_BACKEND_BASE_URL}courses/getCourseById/${courseId}`);
                    const response = await fetch(`https://api.itrain.io/courses/getCourseById/${courseId}`);

                    const data = await response.json();
                    setCourseDetails(data.course); // Set the course details
                    // console.log(data.course); // Debugging the course details
                } catch (error) {
                    // console.error("Error fetching course details:", error);
                }
            }
        };

        fetchCourseDetails();
    }, [courseId]);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <section className="blog-section padding">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 sm-padding">
                        <div className="row-gap">
                            <div className="service-details">
                                {courseDetails && (
                                    <>
                                        <div style={{ marginBottom: '25px' }}>
                                            <span
                                                className="text-13 rounded-pill float-end"
                                                style={{
                                                    display: "inline-block", padding: "10px",
                                                    borderRadius: "10px",
                                                    backgroundColor: "#FF001E",
                                                    color: "#fff",
                                                    marginLeft: "auto",
                                                }}
                                            >
                                                {courseDetails.courseCategory}
                                            </span>

                                            <h2>{courseDetails.courseTitle}</h2>
                                        </div>

                                        <div className="service-featured-img">
                                            {courseDetails?.courseVideo ? (
                                                <video
                                                    id="player"
                                                    className="player"
                                                    playsInline
                                                    controls
                                                    controlsList="nodownload noremoteplayback"
                                                    style={{ width: "100%", height: "auto", objectFit: "cover" }}
                                                >
                                                    <source src={courseDetails.courseVideo} type="video/mp4" />
                                                    <source src={courseDetails.courseVideo} type="video/webm" />
                                                    Your browser does not support the video tag.
                                                </video>
                                            ) : (
                                                <p className="text-gray-300">No video available for this course.</p>
                                            )}
                                        </div>

                                        <div style={{ marginTop: "20px" }}>
                                            <h2>About this course</h2>
                                            <div className="service-features">
                                                <p>{courseDetails.courseDescription}</p>
                                            </div>
                                        </div>


                                        
                                        <div style={{ marginTop: "25px" }}>
    <h2>Course Curriculum</h2>
    <div className="service-features" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
        {courseDetails.courseCurriculum.map((enrollee, index) => (
            <div
                key={index}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: 'normal',
                    gap: '10px',
                    lineHeight: '1.5rem'
                }}
            >
                <i
                    className="fa-solid fa-chevron-right"
                    style={{ color: '#FF001E' }}
                />
                <p style={{ margin: 5 }}>{enrollee}</p>
            </div>
        ))}
    </div>
</div>


                                        <div style={{ marginTop: "20px" }}>
                                            <h2>Why You Should Join</h2>
                                            <div className="row gy-lg-0 gy-4">
                                                {courseDetails.whyShouldJoin.map((reason, index) => (
                                                    <p key={index}>{reason}</p>
                                                ))}
                                            </div>
                                        </div>

                                        <div style={{ marginTop: "20px" }}>
                                            <h2>Certification</h2>
                                            <p> {courseDetails.certification} </p>
                                            <ul className="post-details-gallery">
                                                <li><img src="https://titatechnologies.com/assets/img/certificates.jpg" alt="img" /></li>
                                            </ul>
                                        </div>

                                        <div style={{ marginTop: "25px" }}>
                                            <h2>Who Can Enroll</h2>
                                            <ul className="service-features">
                                                <ul className="check-list">
                                                    {courseDetails.whoCanEnroll.map((enrollee, index) => (
                                                        <div
                                                            key={index}
                                                            style={{ display: 'flex', alignItems: 'center', fontWeight: 'normal', gap: '10px', lineHeight: '1.5rem' }}>
                                                            <i className="fa-solid fa-chevron-right"
                                                                style={{ color: '#FF001E' }}
                                                            />
                                                            <p style={{ margin: 5 }}>{enrollee}</p>
                                                        </div>
                                                    ))}
                                                </ul>
                                            </ul>
                                        </div>




                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Sidebar content */}
                    <div className="col-lg-4 sm-padding">

                        <div className="sidebar-widget">
                            <div className="widget-title">
                                <h3 style={{ fontWeight: 'bold', fontSize: '25px' }}>What You Will Learn</h3>
                                <ul className="service-features">
                                    <ul className="check-list">
                                        {courseDetails?.whatYouWillLearn.map((learn, index) => (
                                            <div
                                                key={index}
                                                style={{ display: 'flex', alignItems: 'center', fontWeight: 'normal', gap: '10px', lineHeight: '1.5rem' }}>
                                                <i className="fa-solid fa-chevron-right"
                                                    style={{ color: '#FF001E' }}
                                                />
                                                <p style={{ margin: 5 }}>{learn}</p>
                                            </div>
                                        ))}
                                    </ul>
                                </ul>

                            </div>
                        </div>

                        <div className="sidebar-widget">
                            <div className="widget-title">
                                <h3 style={{ fontWeight: 'bold', fontSize: '25px' }}>Key Features</h3>
                                <ul className="service-features">
                                    <ul className="check-list">
                                        {courseDetails?.keyFeatures.map((feature, index) => (
                                            <div
                                                key={index}
                                                style={{ display: 'flex', alignItems: 'center', fontWeight: 'normal', gap: '10px', lineHeight: '1.5rem' }}>
                                                <i className="fa-solid fa-chevron-right"
                                                    style={{ color: '#FF001E' }}
                                                />
                                                <p style={{ margin: 5 }}>{feature}</p>
                                            </div>
                                        ))}
                                    </ul>
                                </ul>
                            </div>
                        </div>



                        <div className="sidebar-widget">
                            <div className="widget-title">
                                <h3 style={{ fontWeight: 'bold', fontSize: '25px' }}>IT Skills Covered</h3>
                                <ul className="service-features">
                                    <ul className="check-list">
                                        {courseDetails?.itSkillsCovered.map((skill, index) => (
                                            <div
                                                key={index}
                                                style={{ display: 'flex', alignItems: 'center', fontWeight: 'normal', gap: '10px', lineHeight: '1.5rem' }}>
                                                <i className="fa-solid fa-chevron-right"
                                                    style={{ color: '#FF001E' }}
                                                />
                                                <p style={{ margin: 5 }}>{skill}</p>
                                            </div>
                                        ))}
                                    </ul>
                                </ul>

                            </div>
                        </div>

                        {/* Subscribe section  */}
                        {/* <div className="flex items-center justify-center min-h-screen bg-gray-100 p-6">
                            <div className="w-full max-w-3xl bg-white shadow-lg rounded-lg p-8" data-wow-delay="200ms">
                                <nav className="feature-tab-nav">
                                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                        <button className="nav-link active" id="nav-beginner-tab" data-bs-toggle="tab" data-bs-target="#nav-beginner" type="button" role="tab" aria-controls="nav-beginner" aria-selected="true">Beginner</button>
                                        <button className="nav-link" id="nav-intermediate-tab" data-bs-toggle="tab" data-bs-target="#nav-intermediate" type="button" role="tab" aria-controls="nav-intermediate" aria-selected="false">Intermediate</button>
                                        <button className="nav-link" id="nav-advanced-tab" data-bs-toggle="tab" data-bs-target="#nav-advanced" type="button" role="tab" aria-controls="nav-advanced" aria-selected="false">Advanced</button>
                                    </div>
                                </nav>
                                <div className="tab-content" id="nav-tabContent">
                                    <div className="tab-pane fade active show" id="nav-beginner" role="tabpanel" aria-labelledby="nav-beginner-tab">
                                        <div className="tab-inner">
                                            <div className="feature-tab-content">
                                                <h3>Beginner</h3>
                                                <p>Starting with the basics to build a strong foundation in software development.</p>
                                                <button
                                                    className="default-btn  fade-in-right"
                                                    data-wow-delay="100ms"
                                                    onClick={openModal}
                                                    style={{ zIndex: isModalOpen ? -1000 : 100 }}
                                                    >
                                                    Subscribe Now
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="nav-advanced" role="tabpanel" aria-labelledby="nav-advanced-tab">
                                        <div className="tab-inner">
                                            <div className="feature-tab-content">
                                                <h3>Advanced</h3>
                                                <p>Mastering complex concepts and advanced techniques for seasoned professionals.</p>
                                                <button
                                                    className="default-btn  fade-in-right"
                                                    data-wow-delay="100ms"
                                                    onClick={openModal}
                                                    style={{ zIndex: isModalOpen ? -1000 : 100 }}
                                                    >
                                                    Subscribe Now
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="nav-intermediate" role="tabpanel" aria-labelledby="nav-intermediate-tab">
                                        <div className="tab-inner">
                                            <div className="feature-tab-content">
                                                <h3>Intermediate</h3>
                                                <p>Building on foundational skills to tackle more challenging projects and tasks.</p>
                                                <button
                                                    className="default-btn fade-in-right"
                                                    data-wow-delay="100ms"
                                                    onClick={openModal}
                                                    style={{ zIndex: isModalOpen ? -1000 : 100 }}
                                                    >
                                                    Subscribe Now
                                                   
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}


<div className="sidebar-widget">
                            <div className="widget-title">
                                <h3 style={{ fontWeight: 'bold', fontSize: '25px' }}>Subscription</h3>
                                <button
                                    className="default-btn"
                                    onClick={openModal}
                                   
                                >
                                    Subscribe Now
                                </button>
                             

                            </div>
                        </div>



                    </div>
                </div>
            </div>

            {/* Modal */}
            <Modal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                contentLabel="Subscription Modal"
                ariaHideApp={false}
                className="modal-content"
                overlayClassName="modal-overlay"
                style={{
                    overlay: { background: "rgba(0, 0, 0, 0.5)", position: "fixed", top: 0, left: 0, right: 0, bottom: 0, display: "flex", justifyContent: "center", alignItems: "center", },
                    content: { background: "linear-gradient(to right, #fbc2eb, #a6c1ee)", padding: "30px", borderRadius: "8px", width: "400px", textAlign: "center"},
         
                }}
            >
                <div className="popup-content">
                    <div style={{ borderBottom: "2px solid #0a0909", marginBottom: "15px" }}>
                        <h2 style={{ color: "#0A0909", margin: "20px 0 10px" }}>
                            <span style={{ color: "#0A0909", fontSize: "50px", fontWeight: "bold" }}> $199 </span>USD/mon
                        </h2>
                    </div>
                    <ul className="check-list" style={{ listStyleType: "none", padding: 0 }}>
                        <li style={{ marginBottom: "10px" }}><i className="fa-solid fa-check" />Unlimited access to all courses</li>
                        <li style={{ marginBottom: "10px" }}><i className="fa-solid fa-check" />Only $199 USD monthly subscription</li>
                        <li style={{ marginBottom: "10px" }}><i className="fa-solid fa-check" />LIVE Sessions with flexible timings</li>
                        <li style={{ marginBottom: "10px" }}><i className="fa-solid fa-check" />Certificates and Career Guidance</li>
                        <li style={{ marginBottom: "10px" }}><i className="fa-solid fa-check" />FREE LMS access (iTrain)</li>
                        <li style={{ marginBottom: "10px" }}><i className="fa-solid fa-check" />Weekdays and Weekend Classes</li>
                    </ul>
                    <Link to="/signup">
                        <button
                            style={{ backgroundColor: "#FF001E", color: "#fff", padding: "12px 24px", fontSize: "16px", border: "none", borderRadius: "8px", cursor: "pointer", boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease", textTransform: "uppercase", letterSpacing: "1px", fontWeight: "bold", }}
                            onMouseOver={(e) => e.target.style.backgroundColor = "#0A0909"}
                            onMouseOut={(e) => e.target.style.backgroundColor = "#FF001E"}>
                            Subscribe Now
                        </button>
                    </Link>
                </div>
            </Modal>
        </section>
    );
}

export default CourseviewDetails;